import {
    RawAnchorTagData,
    RawHeadingData,
    RawParagraphData,
    RawTagData,
} from '@activebrands/core-web/libs/storyblok/storyblok';
import { RawBackgroundData } from '@activebrands/core-web/libs/storyblok/utils/transform-flexible-background';

export type CmsContentHorizontalAlignment = 'center' | 'left' | 'right';
export type CmsContentVerticalAlignment = 'bottom' | 'center' | 'top';
export type CmsHeadingElementType = 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
export type CmsHeadingStyle = 'lg' | 'md' | 'sm';
export type CmsSmMdHeadingStyle = Extract<CmsHeadingStyle, 'md' | 'sm'>;

export const isCmsHeadingStyle = (value: string): value is CmsHeadingStyle =>
    value === 'sm' || value === 'md' || value === 'lg';

export const isCmsSmMdHeadingStyle = (value: string): value is CmsSmMdHeadingStyle => value === 'sm' || value === 'md';

// Storyblok preview + in-page anchor fields shared by most CMS modules.
export interface CmsEditableFields {
    _editable?: string;
    _uid?: string;
    anchorTag?: RawAnchorTagData[];
}

// Desktop/mobile background bloks used by flexible-style modules.
export interface CmsFlexibleBackgroundFields {
    backgroundDesktop?: RawBackgroundData[];
    backgroundMobile?: RawBackgroundData[];
}

// Content position within a media module (matches getPositionStyles).
export interface CmsContentAlignmentFields {
    contentHorizontalAlignment?: CmsContentHorizontalAlignment;
    contentVerticalAlignment?: CmsContentVerticalAlignment;
}

// Heading blok + style preset from Storyblok
export interface CmsHeadingFields {
    heading?: RawHeadingData | RawHeadingData[];
    headingStyle?: CmsHeadingStyle;
}

// Common text overlay fields on promotional / media modules
export interface CmsTextOverlayFields {
    paragraph?: RawParagraphData | RawParagraphData[];
    tag?: RawTagData | RawTagData[];
    textColor?: string;
}
